import * as React from 'react';
import { ResetPasswordForm, LogoCentered } from 'src/app/Partials';

import './ResetPassword.page.scss';
import { Link } from 'react-router-dom';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ResetPassword.messages';

export interface ResetPasswordPageProps {
}

export class ResetPasswordPage extends React.Component<ResetPasswordPageProps, any> {
  public render() {
    return (
      <div className="page-resetpassword d-flex justify-content-center align-items-center h-100">
        <div className="inner w-100 pt-5 pb-5">
          <div className="row m-0 mb-4">
            <div className="col-12">
              <LogoCentered />
            </div>
          </div>
          <ResetPasswordForm />
          <div className="meta d-flex mt-2">
            <div className="col-6 text-left">
              <p className="small">
                <Link to="/">
                  <span>
                    <FormattedMessage {...MESSAGES.resetPasswordButton} />
                  </span>
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
